import {Observable, Subscription} from 'rxjs';

import IVolumeStore   from '../../Volume/Interfaces/IVolumeStore';
import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToPlayRejection = (
    playRejection$: Observable<void>,
    playbackStore: IPlaybackStore,
    volumeStore: IVolumeStore
): Subscription =>
    playRejection$
        .subscribe(() => {
            if (volumeStore.value.isForceMuted) {
                playbackStore.actions.pause();
            }
        });

export default subscribeToPlayRejection;